module.exports = __webpack_public_path__ + "fonts/ralewaybolditalic.5c64361.ttf";